﻿import { required } from 'vuelidate/lib/validators';
import Pikaday from 'Pikaday';

export default {
    name: 'deliverydate',
    template: '#deliverydate-template',
    mounted: function () {
        this.$watch('$v.$invalid', () => {
            this.updateValidState();
        });
        this.updateValidState();

        this.earliestDate = this.getDate(this.viewmodel.firstAvailableDateEpoch);
        this.selectedDate = this.getDate(this.viewmodel.selectedDateEpoch);
        this.showCancellationText = this.viewmodel.cancellationText != null && this.viewmodel.cancellationText != "";

        var choosenDate = this.viewmodel.userHasChoosenCustomDate;
        if (choosenDate != null) {
            this.viewmodel.userHasChoosenCustomDate = choosenDate.toString();
            this.customDateChosen = this.viewmodel.userHasChoosenCustomDate;
        }
        const self = this;
        var picker = new Pikaday({
            field: document.getElementById('datepicker'),
            firstDay: 1,
            defaultDate: self.selectedDate || self.earliestDate,
            setDefaultDate: true,
            format: 'DD/MM/YYYY',
            bound: false, // use theme: ts-datepicker--inline when this value equals to false
            theme: 'ts-datepicker ts-datepicker--inline',
            disableWeekends: true,
            i18n: {
                months: self.viewmodel.monthNames,
                weekdaysShort: self.viewmodel.dayNamesShort,
                weekdays: self.viewmodel.dayNames,
                nextMonth: '',
                previousMonth: ''
            },
            disableDayFn: function (d) {
                if(self.viewmodel.isFriday && self.viewmodel.isCoaxOrDsl){
                    //Creating a date format from d
                    var DD = ('0' + d.getDate()).slice(-2);
                    var MM = ('0' + (d.getMonth() + 1)).slice(-2);
                    var YYYY = d.getFullYear();
                    var date = YYYY + '-' + MM + '-' + DD;
                    for (let i = 0; i < self.viewmodel.disabledDates.length; i++) {
                        if(date == self.viewmodel.disabledDates[i].slice(0,10)) //need to slice because we only require date to compare
                        {
                            return d;
                        }
                    }
                    return (self.earliestDate > d || d.getDay() === 5);
                }
                return (self.earliestDate > d);
            }
        });


    },
    data: () => ({
        earliestDate: Date,
        selectedDate: Date,
        customDateChosen: "false",
        showCancellationText: false
    }),
    props: ['viewmodel', 'blockid'],
    validations: {
        customDateChosen: {
            required
        }
    },
    methods: {
        getDate: function (epochTime) {
            if (epochTime == null || epochTime === 0) {
                return null;
            }
            const date = new Date(0);
            date.setUTCSeconds(epochTime);

            return date;
        },
        updateValidState() {
            this.$store.dispatch('updateValidState', { invalid: this.$v.$invalid, blockId: this.blockid });
        }
    }
}
